import { render, staticRenderFns } from "./DashboardRefurbishStats.vue?vue&type=template&id=5365551a&"
import script from "./DashboardRefurbishStats.vue?vue&type=script&lang=js&"
export * from "./DashboardRefurbishStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports